import { render } from "./CertificateDescription.vue?vue&type=template&id=320fd180"
import script from "./CertificateDescription.vue?vue&type=script&lang=js"
export * from "./CertificateDescription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__